import history from '@src/history';
import * as NavConfig from '@common/NavConfig';
import { WalletItemStore } from '@store/Statistic/WalletHistory/WalletHistoryStore';

class GoToPage {

  //获取代理页面地址
  getProxyItemPath(userId,userName)
  {
    let path = NavConfig.getNavNodeByName('代理信息列表').path;
    path = path.replace(':id',userId);
    path = path.replace(':username',userName);
    return path;
  }
  //跳转代理页面地址
  goProxyItemPath(userId,userName)
  {
    let path = this.getProxyItemPath(userId,userName);
    console.log("fff",path)
    this.go(path);
  }

  //获取用户详情页面地址
  getUserItemPath(type,userId,userName)
  {
    let path = NavConfig.getNavNodeByName('会员列表').path;
    path = path.replace(':type',type);
    path = path.replace(':id',userId);
    path = path.replace(':username',userName);
    return path;
  }
  //跳转用户详情页面地址
  goUserItemPath(type,userId,userName,state)
  {
    let path = this.getUserItemPath(type,userId,userName);
    this.go(path,state)
  }

  // 跳转用户密码设置界面
  goSettingPath() {
    let path = NavConfig.getNavNodeByName('修改密码').path;
    this.go( path );
  }

  // 跳转充值记录
  goRechargePath(state) {
    console.log(state)
    let path = NavConfig.getNavNodeByName('充值记录').path;
    state.type = WalletItemStore.Type_Recharge;
    this.go(path,state);
  }

  // 跳转提现记录
  goCashPath(state) {
    let path = NavConfig.getNavNodeByName('提现记录').path;
    state.type = WalletItemStore.Type_Cash;
    this.go(path,state);
  }

  // 跳转投注记录
  goRakeBackPath(state) {
    let path = NavConfig.getNavNodeByName('投注返佣记录').path;
    this.go(path,state);
  }

  // 跳转到数据统计页面
  goMySummaryPath(userId, username) {
    let path = NavConfig.getNavNodeByName('直属会员统计(包括自己)').path;
    path = path.replace(':id',userId);
    path = path.replace(':username',username);
    this.go( path );
  }


  go(path,state)
  {
    if (path == undefined || path == '')
    {
      return
    }

    history.push(path,state)
  }

}


let gotopage = new GoToPage();

export default gotopage;



// WEBPACK FOOTER //
// ./src/common/GoToPage.js